/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_P_Li5Inputs */

const tr_mesafeli_s8_p_li5 = /** @type {(inputs: Mesafeli_S8_P_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri'nin kvkk@emonse.com adresine ilettiği veri taleplerini KVKK Madde 13 uyarınca en geç 30 gün içinde sonuçlandırmak; önceden kabul edilmiş sözleşme hükümlerinden doğmuş veri erişimi ve dışa aktarma haklarını yerine getirmek.`)
};

const en_mesafeli_s8_p_li5 = /** @type {(inputs: Mesafeli_S8_P_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To conclude data requests the Customer sends to kvkk@emonse.com within 30 days at the latest pursuant to KVKK Article 13, and to fulfil data access and export rights arising under previously accepted contract provisions.`)
};

const de_mesafeli_s8_p_li5 = /** @type {(inputs: Mesafeli_S8_P_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenanfragen des Kunden an kvkk@emonse.com nach KVKK Artikel 13 spätestens innerhalb von 30 Tagen abschließend bearbeiten und Ansprüche auf Datenzugriff und Export aus bereits angenommenen Vertragsfassungen erfüllen.`)
};

const ru_mesafeli_s8_p_li5 = /** @type {(inputs: Mesafeli_S8_P_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассматривать запросы Клиента о данных, направленные на kvkk@emonse.com, не позднее чем в течение 30 дней согласно статье 13 KVKK, и исполнять права на доступ к данным и экспорт, возникшие из ранее принятых положений договора.`)
};

/**
* | output |
* | --- |
* | "To conclude data requests the Customer sends to kvkk@emonse.com within 30 days at the latest pursuant to KVKK Article 13, and to fulfil data access and expor..." |
*
* @param {Mesafeli_S8_P_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_p_li5 = /** @type {((inputs?: Mesafeli_S8_P_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_P_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_p_li5(inputs)
	if (locale === "de") return de_mesafeli_s8_p_li5(inputs)
	if (locale === "ru") return ru_mesafeli_s8_p_li5(inputs)
	return tr_mesafeli_s8_p_li5(inputs)
});